<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card">
            <el-page-header content="用户列表" :icon="null" title="用户管理">
                <template #extra>
                    <el-button type="primary" @click="searchFun(1)">查询</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                    <el-button @click="handleExport()">
                        导出
                        <el-icon class="el-icon--right">
                            <Download />
                        </el-icon>
                    </el-button>
                </template>
                <el-form :model="search" label-width="100px" class="demo-ruleForm">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="用户标签:" prop="userNature">
                                <el-select v-model="search.userNature" clearable class="m-2" placeholder="请选用户标签"
                                    style="width: 100%" @change="searchFun(1)">
                                    <el-option v-for="item in state.options" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="手机号:" prop="phone">
                                <el-input v-model="search.phone" type="number" placeholder="请输入手机号"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="推荐人手机号:" prop="recommenderPhone">
                                <el-input v-model="search.recommenderPhone" type="number" placeholder="请输入手机号"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%" height="calc(100vh - 295px)" row-key="id"
                v-loading="state.tableLoading">
                <el-table-column prop="phone" label="手机号码" min-width="120px" />
                <el-table-column prop="userNature " label="用户标签" min-width="120px">
                    <template #default="scope">
                        {{ filterUserNature(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column prop="company " label="企业名称" min-width="200px">
                    <template #default="scope">
                        {{ scope.row?.company || '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="recommenderPhone" label="推荐人手机号" min-width="120px" />
                <el-table-column prop="type" label="用户类型" min-width="120px">
                    <template #default="scope">
                        {{ statusMap[scope.row.type] }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="isEnabled" label="用户状态" min-width="100px">
                    <template #default="scope">
                        {{ statusMap1[scope.row.isEnabled] }}
                    </template>
                </el-table-column> -->
                <el-table-column prop="memberType" label="会员类型" min-width="100px" />
                <el-table-column prop="memberStartTime" label="会员开始时间" min-width="180px">
                    <template #default="scope">
                        {{ scope.row.memberStartTime || '--' }}
                    </template>
                </el-table-column>
                <el-table-column prop="memberEndTime" label="会员到期时间" min-width="180px">
                    <template #default="scope">
                        {{ scope.row.memberEndTime || '--' }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="注册时间" min-width="180px" />
                <el-table-column fixed="right" label="操作" width="140px">
                    <template #default="scope">
                        <el-button type="primary" @click="handleEdit(scope.row)" size="small">编辑</el-button>
                        <el-popconfirm title="是否要删除当前数据?" confirm-button-text="是" cancel-button-text="否"
                            @confirm="handleDelete(scope.row)">
                            <template #reference>
                                <el-button type="danger" size="small">删除</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>
    <el-dialog v-model="state.dialogVisible" title="编辑用户" width="40%">
        <el-form ref="userFormRef" :model="state.formValue" :rules="state.formRules" label-width="80px" status-icon>
            <el-form-item label="用户名" prop="userName">
                <el-input v-model="state.formValue.userName" placeholder="请输入用户名" />
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="state.formValue.phone" type="number" placeholder="请输入手机号" disabled />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input v-model="state.formValue.email" type="text" placeholder="请输入邮箱" />
            </el-form-item>
            <el-form-item label="推荐人ID" prop="recommenderId">
                <el-input v-model="state.formValue.recommenderId" type="text" placeholder="请输入推荐人ID" />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="state.dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="dialogConfirm">确认</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { Download } from '@element-plus/icons-vue'
import { getUserListFun, deleteFun, getDetailFun, editFun, exportFun } from "@/api/user"
import { phoneValidator, emailValidator } from "@/util/formValidator";

const search = reactive({
    userName: "",
    phone: "",
    recommenderPhone: "",
    userNature: '',
})
const state = reactive({
    fullLoading: false,
    tableLoading: false,
    dialogVisible: false,
    formValue: {
        userName: '',
        phone: '',
        email: '',
        recommenderId: '',
        id: null
    },
    formRules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        phone: [{ required: true, validator: phoneValidator, trigger: 'blur' }],
        email: [{ validator: emailValidator, trigger: 'blur' }],
    },
    options: [
        { label: "未充值用户", value: 0 },
        { label: "内部用户", value: 1 },
    ],});
const tableData = ref([]);
const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});

const statusMap = {
    1: "微信小程序",
    2: "抖音小程序",
    3: "后台管理系统",
};

const statusMap1 = {
    0: "锁定",
    1: "激活"
};

const userFormRef = ref();
// 行操作 编辑
const handleEdit = (row) => {
    state.fullLoading = true;
    getDetailFun(row.id).then((res) => {
        if (res.data) {
            state.formValue.userName = res.data.userName;
            state.formValue.phone = res.data.phone;
            state.formValue.email = res.data.email ?? '';
            state.formValue.recommenderId = res.data.recommenderId ?? '';
            state.formValue.id = res.data.id;
            state.dialogVisible = true;
        }
    }).finally(() => {
        state.fullLoading = false;
    })
}
// 行操作 删除
const handleDelete = (row) => {
    state.tableLoading = true;
    deleteFun(row.id).then((res) => {
        pagination.current = 1;
        pagination.size = 10;
        intTableData();
    }).finally(() => {
        state.tableLoading = false;
    });
}
const handleExport = () => {
    state.fullLoading = true;
    exportFun().finally(() => {
        state.fullLoading = false;
    })
}
// 查询 1查询 2重置
const searchFun = (type) => {
    if (type == 2) {
        search.userNature = '';
        search.userName = '';
        search.phone = '';
        search.recommenderPhone = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.tableLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }
    for (let key in search) {
        if (search[key]) {
            params.keys.push(key);
            params.formValue[key] = search[key];
        }
    }
    getUserListFun(params).then((res) => {
        tableData.value = res.data.records;
        pagination.total = res.data.total;
    }).finally(() => {
        state.tableLoading = false;
    });
}
// 编辑确认
const dialogConfirm = () => {
    // 1.校验表单
    userFormRef.value.validate((valid) => {
        if (valid) {
            state.fullLoading = true;
            const params = {
                userName: state.formValue.userName,
                email: state.formValue.email,
                recommenderId: state.formValue.recommenderId,
                id: state.formValue.id,
            }
            editFun(params).then((res) => {
                state.dialogVisible = false;
                intTableData();
            }).finally(() => {
                state.fullLoading = false;
            });
        }
    })
}
// 编辑确认
const filterUserNature = (row) => {
    const userNature = row?.userNature;
    if (userNature === undefined || userNature === null || userNature === '') {
        return '';
    }
    const node = state.options.find((item) => item.value == userNature);
    return node?.label || '--';
}
onMounted(() => {
    intTableData();
});
</script>
<style lang="scss" scoped>
// .el-table {
//     margin-top: 30px;
// }

.demo-ruleForm {
    margin-top: 15px;
}

.pagination-box {
    text-align: right;
}

.el-pagination {
    margin-top: 15px;
    float: right;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
}

::v-deep .el-input-number .el-input__inner {
    text-align: left;
}
</style>